// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nunito-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nunito-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Nunito-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Nunito-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Nunito-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Nunito-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Nunito-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Nunito-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Nunito-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Nunito-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Nunito-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Nunito-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/Nunito-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/fonts/Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/fonts/Nunito-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/fonts/Nunito-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Nunito-Black';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-BlackItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-BoldItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-ExtraBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-ExtraBoldItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-ExtraLight';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-ExtraLightItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-Italic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-LightItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-MediumItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-SemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
}

@font-face {
    font-family: 'Nunito-SemiBoldItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
}

body {
    font-family: 'Nunito-Regular', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,+DAAkE;AACtE;;AAEA;IACI,iCAAiC;IACjC,+DAAwE;AAC5E;;AAEA;IACI,0BAA0B;IAC1B,+DAAiE;AACrE;;AAEA;IACI,gCAAgC;IAChC,+DAAuE;AAC3E;;AAEA;IACI,+BAA+B;IAC/B,+DAAsE;AAC1E;;AAEA;IACI,qCAAqC;IACrC,+DAA4E;AAChF;;AAEA;IACI,gCAAgC;IAChC,+DAAuE;AAC3E;;AAEA;IACI,sCAAsC;IACtC,+DAA6E;AACjF;;AAEA;IACI,4BAA4B;IAC5B,+DAAmE;AACvE;;AAEA;IACI,2BAA2B;IAC3B,+DAAkE;AACtE;;AAEA;IACI,iCAAiC;IACjC,gEAAwE;AAC5E;;AAEA;IACI,4BAA4B;IAC5B,gEAAmE;AACvE;;AAEA;IACI,kCAAkC;IAClC,gEAAyE;AAC7E;;AAEA;IACI,6BAA6B;IAC7B,gEAAoE;AACxE;;AAEA;IACI,8BAA8B;IAC9B,gEAAqE;AACzE;;AAEA;IACI,oCAAoC;IACpC,gEAA2E;AAC/E;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":["@font-face {\n    font-family: 'Nunito-Black';\n    src: url('../../assets/fonts/Nunito-Black.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-BlackItalic';\n    src: url('../../assets/fonts/Nunito-BlackItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-Bold';\n    src: url('../../assets/fonts/Nunito-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-BoldItalic';\n    src: url('../../assets/fonts/Nunito-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-ExtraBold';\n    src: url('../../assets/fonts/Nunito-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-ExtraBoldItalic';\n    src: url('../../assets/fonts/Nunito-ExtraBoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-ExtraLight';\n    src: url('../../assets/fonts/Nunito-ExtraLight.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-ExtraLightItalic';\n    src: url('../../assets/fonts/Nunito-ExtraLightItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-Italic';\n    src: url('../../assets/fonts/Nunito-Italic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-Light';\n    src: url('../../assets/fonts/Nunito-Light.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-LightItalic';\n    src: url('../../assets/fonts/Nunito-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-Medium';\n    src: url('../../assets/fonts/Nunito-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-MediumItalic';\n    src: url('../../assets/fonts/Nunito-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-Regular';\n    src: url('../../assets/fonts/Nunito-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-SemiBold';\n    src: url('../../assets/fonts/Nunito-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Nunito-SemiBoldItalic';\n    src: url('../../assets/fonts/Nunito-SemiBoldItalic.ttf') format('truetype');\n}\n\nbody {\n    font-family: 'Nunito-Regular', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
